import { render } from "./loading-indicator.vue?vue&type=template&id=a49f9cb0"
import script from "./loading-indicator.vue?vue&type=script&lang=js"
export * from "./loading-indicator.vue?vue&type=script&lang=js"

import "./loading-indicator.vue?vue&type=style&index=0&id=a49f9cb0&lang=css"

import exportComponent from "C:\\m-tech\\WMExtranet2.0\\WebUI\\WiseApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__